import { useT } from "@/i18n/locale-context";

/**
 * Permanent "consult a specialist" banner shown on protocols where the
 * non-diagnostic boundary requires a clear referral (e.g. mole ABCDE).
 * Visually distinct from the generic disclaimer banner.
 */
export function ReferralBanner({ variant = "dermato" }: { variant?: "dermato" | "physician" | "midwife" }) {
  const t = useT();
  const titleKey =
    variant === "midwife"
      ? "protocols.referral.midwife.title"
      : variant === "physician"
        ? "protocols.referral.physician.title"
        : "protocols.referral.derma.title";
  const descKey =
    variant === "midwife"
      ? "protocols.referral.midwife.desc"
      : variant === "physician"
        ? "protocols.referral.physician.desc"
        : "protocols.referral.derma.desc";
  return (
    <div
      role="note"
      className="mt-4 rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm"
    >
      <strong className="block mb-1 text-destructive">{t(titleKey)}</strong>
      <span className="text-foreground/80">{t(descKey)}</span>
    </div>
  );
}
